module.exports = __webpack_public_path__ + "media/entities/1124-782889e4.png";